import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/fb/github/brigand/pattahn/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/fb/github/brigand/pattahn/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cdf9baa2f007d8a29a4df8d45c12be32.js')["default"];

export default Object.assign({}, scope_0, scope_1);